import * as cookieHelper from './cookie-helper';
import { formConstants } from '../components/utils/constants/form-constants';
import * as signInFormApi from '../store/api/sign-in-form-api';
import userService from '../../../general/js/user/user-service';
import { reloadToBasePage } from '../../../general/js/utils';

export const activityHelper = (function () {

    let isOnPage = true;
    let timeoutHandle;

    function _attachUserActivityEventListener() {

        if ('hidden' in document) {
            document.addEventListener('visibilitychange', _onChange);
            return;
        }

        if ('mozHidden' in document) {
            document.addEventListener('mozvisibilitychange', _onChange);
            return;
        }

        if ('webkitHidden' in document) {
            document.addEventListener('webkitvisibilitychange', _onChange);
            return;
        }

        if ('msHidden' in document) {
            document.addEventListener('msvisibilitychange', _onChange);
            return;
        }

        window.onpageshow = _onChange;
        window.onpagehide = _onChange;
    }

    function _onChange() {
        isOnPage = isOnPage === undefined ? true : !isOnPage;

        if (isOnPage) {
            return;
        }

        const maxIdleTimeInSeconds = cookieHelper.getCookie(formConstants.maxIdleTimeInSeconds);
        if (!maxIdleTimeInSeconds) {
            return;
        }
        const parsedMaxIdleTimeInSeconds = maxIdleTimeInSeconds ? parseInt(maxIdleTimeInSeconds, 10) : NaN;

        if (Number.isNaN(parsedMaxIdleTimeInSeconds)) {
            return;
        }

        if (parsedMaxIdleTimeInSeconds <= 0) {
            return;
        }

        window.clearTimeout(timeoutHandle);
        timeoutHandle = setTimeout(_timeOutFunction, parsedMaxIdleTimeInSeconds * 1000);
    }

    function _timeOutFunction() {
        if (isOnPage) {
            return;
        }

        signInFormApi.signOutUser().then(() => {
            userService.setAccessTokenCookie(null);
            cookieHelper.setCookie(formConstants.maxIdleTimeInSeconds, 0);
            reloadToBasePage();
        });
    }

    function _refreshMyAccountStyle() {
        const currentAddress = window.location.href;
        const randaPage = document.body.getElementsByClassName('randa-page')[0];

        if (!randaPage) {
            return;
        }

        if (!currentAddress.includes('account/profile')) {
            randaPage.classList.remove('my-account-page');
            return;
        }

        randaPage.classList.add('my-account-page');
    }

    return {
        handleUserIdleTime: () => {
            _attachUserActivityEventListener();
        },
        refreshMyAccountStyle: () => {
            _refreshMyAccountStyle();
        }
    };
}());
